import { useLoadingStore } from '@/stores/loading-store';

export const useWithLoading = <T extends (...args: any[]) => Promise<void>>(
  fn: T,
) => {
  console.info('with-loading.ts_1');

  const { startLoading, stopLoading } = useLoadingStore();

  return async (...args: Parameters<T>): Promise<void> => {
    console.info('with-loading.ts_2');

    startLoading();
    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      console.info('with-loading.ts_3');
      await fn(...args);
    } finally {
      console.info('with-loading.ts_4');
      stopLoading();
    }
  };
};
